import { createContext } from 'react';
export var ScalprumContext = createContext({
    initialized: false,
    config: {},
    api: {},
    pluginStore: {},
});
//# sourceMappingURL=scalprum-context.js.map